var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567702137.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "center"
  }, [_vm._m(0), _c("div", {
    staticClass: "middle"
  }), _c("div", {
    staticClass: "right"
  }, [_vm._m(1), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("投喂记录")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "table"
  }, [_vm._m(2), _c("div", {
    staticClass: "t-content"
  }, _vm._l(_vm.warn_list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "tr",
      class: {
        active: index == _vm.active
      },
      on: {
        click: function click($event) {
          _vm.active = index;
        }
      }
    }, [index == _vm.active ? _c("img", {
      attrs: {
        src: "https://oss-mng.rich-link.cn/undefined/20260730/1785403683241.png",
        alt: ""
      }
    }) : _vm._e(), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "155px"
      }
    }, [_vm._v(_vm._s(_vm.dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss")))]), _c("div", {
      staticClass: "td one-overflow",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.labName))]), _c("div", {
      staticClass: "td",
      staticStyle: {
        flex: "none",
        width: "80px"
      }
    }, [_vm._v(_vm._s(item.caseCount))])]);
  }), 0)])])])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "left"
  }, [_c("div", {
    staticClass: "item item-1"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("设备数量")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart1"
    }
  })])]), _c("div", {
    staticClass: "item item-2"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("7日投喂总量")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart2"
    }
  })])]), _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("7日设备投喂总量")]), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "chart",
    attrs: {
      id: "chart2"
    }
  })])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "date"
  }, [_c("div", [_c("div", [_vm._v("14:54:15")]), _c("div", [_vm._v("2026-02-07")]), _c("div", [_vm._v("星期三")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "155px"
    }
  }, [_vm._v("时间")]), _c("div", {
    staticClass: "td"
  }, [_vm._v("投饲机")]), _c("div", {
    staticClass: "td",
    staticStyle: {
      flex: "none",
      width: "80px"
    }
  }, [_vm._v("投饲重量")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };